import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const EMBLEM = "/brand/emblem_white.png";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      toast.success("Signed in.");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invalid credentials.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-32 pb-20" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border border-[color:var(--hm-line)] p-10 space-y-5" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-4">
          <img src={EMBLEM} alt="" className="h-10 w-auto" />
          <div>
            <p className="hm-eyebrow">Har-Monic · Admin</p>
            <h1 className="font-display text-[28px] leading-none" style={{ fontWeight: 400 }}>Sign in</h1>
          </div>
        </div>
        <input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="hm-input" required data-testid="admin-email" autoFocus />
        <input type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="hm-input" required data-testid="admin-password" />
        <button type="submit" disabled={busy} className="hm-btn w-full justify-center" data-testid="admin-login-submit">
          {busy ? "Signing in…" : "Sign in →"}
        </button>
      </form>
    </div>
  );
}
